function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Modal, { ModalProvider as BaseModalProvider } from 'styled-react-modal';
import React from 'react';
import { getReactHtmlObject } from '../html-renderer';
import { ModalActionButton, ModalBackground, ModalBody, ModalButtonWrapper, ModalCloseButton, ModalCloseButtonAndContainerWrapper, ModalContainer, ModalFooterText, ModalFooterWrapper, ModalHeader, ModalHeaderTitleAndSubtitleWrapper, ModalIcon, ModalSubtitle, ModalTitle } from './style';
export class ModalProvider extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(BaseModalProvider, {
      backgroundComponent: ModalBackground
    }, this.props.children);
  }

}
export default class HippoModal extends React.Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "state", {
      isOpen: this.props.isOpen,
      isValid: typeof this.props.isValid === 'undefined' ? true : this.props.isValid
    });

    _defineProperty(this, "toggleModal", () => {
      this.setState(state => ({
        isOpen: !state.isOpen
      }));
    });

    _defineProperty(this, "onPrimaryButtonClick", () => {
      var {
        onPrimaryButtonClick
      } = this.props;

      if (onPrimaryButtonClick) {
        onPrimaryButtonClick();
      }
    });

    _defineProperty(this, "onSecondaryButtonClick", () => {
      var {
        onSecondaryButtonClick
      } = this.props;

      if (onSecondaryButtonClick) {
        onSecondaryButtonClick();
      }
    });

    _defineProperty(this, "setIsValid", isValid => {
      this.setState({
        isValid
      });
    });

    _defineProperty(this, "ModalHeaderTitleAndSubtitleSection", () => /*#__PURE__*/React.createElement(ModalHeaderTitleAndSubtitleWrapper, null, /*#__PURE__*/React.createElement(ModalTitle, {
      type: 'heading7'
    }, /*#__PURE__*/React.createElement("p", {
      dangerouslySetInnerHTML: getReactHtmlObject(this.props.title)
    })), this.props.subtitle && /*#__PURE__*/React.createElement(ModalSubtitle, {
      type: ['heading8', 'body5', 'body5'],
      color: ['primary700', 'gray600', 'gray600']
    }, /*#__PURE__*/React.createElement("p", {
      dangerouslySetInnerHTML: getReactHtmlObject(this.props.subtitle)
    }))));

    _defineProperty(this, "ModalFooterSection", () => {
      var {
        secondaryButtonText,
        primaryButtonText,
        footerText
      } = this.props;
      return /*#__PURE__*/React.createElement(ModalFooterWrapper, null, (secondaryButtonText || primaryButtonText) && /*#__PURE__*/React.createElement(ModalButtonWrapper, null, secondaryButtonText && /*#__PURE__*/React.createElement(ModalActionButton, {
        size: 'small',
        styleType: 'secondary',
        onClick: this.onSecondaryButtonClick
      }, secondaryButtonText), primaryButtonText && /*#__PURE__*/React.createElement(ModalActionButton, {
        size: 'small',
        styleType: 'primary',
        onClick: this.onPrimaryButtonClick,
        disabled: !this.state.isValid
      }, primaryButtonText)), footerText && /*#__PURE__*/React.createElement(ModalFooterText, {
        type: 'body6',
        color: 'gray600'
      }, Array.isArray(footerText) ? footerText.map((text, index) => /*#__PURE__*/React.createElement(React.Fragment, {
        key: index
      }, /*#__PURE__*/React.createElement("p", {
        dangerouslySetInnerHTML: getReactHtmlObject(text)
      }), index < footerText.length - 1 && /*#__PURE__*/React.createElement("br", null))) : /*#__PURE__*/React.createElement("p", {
        dangerouslySetInnerHTML: getReactHtmlObject(footerText)
      })));
    });
  }

  componentDidUpdate(prevProps) {
    var newState = {};

    if (prevProps.isOpen !== this.props.isOpen) {
      newState.isOpen = this.props.isOpen;
    }

    if (prevProps.isValid !== this.props.isValid) {
      newState.isValid = typeof this.props.isValid === 'undefined' ? true : this.props.isValid;
    }

    if (Object.keys(newState).length) {
      this.setState(prevState => _objectSpread(_objectSpread({}, prevState), newState));
    }
  }

  render() {
    var childrenWithProps;

    if (this.props.children) {
      childrenWithProps = React.Children.map(this.props.children, child => {
        if (child && /*#__PURE__*/React.isValidElement(child)) {
          return /*#__PURE__*/React.cloneElement(child, {
            setIsValid: this.setIsValid
          });
        } else {
          return child;
        }
      });
    }

    var ModalHeaderTitleAndSubtitleSection = this.ModalHeaderTitleAndSubtitleSection;
    var ModalFooterSection = this.ModalFooterSection;
    return /*#__PURE__*/React.createElement(Modal, {
      isOpen: this.state.isOpen,
      beforeClose: this.props.beforeClose,
      beforeOpen: this.props.beforeOpen,
      afterOpen: this.props.afterOpen,
      afterClose: this.props.afterClose,
      onEscapeKeydown: this.props.disableClose ? undefined : this.props.onEscapeKeydown,
      onBackgroundClick: this.props.disableClose || this.props.disableBackgroundClick ? undefined : this.props.onBackgroundClick
    }, /*#__PURE__*/React.createElement(ModalCloseButtonAndContainerWrapper, {
      "data-test-id": this.props['data-test-id'],
      size: this.props.size
    }, !this.props.disableClose && /*#__PURE__*/React.createElement(ModalCloseButton, {
      "data-test-id": 'modal-close-button',
      onClick: this.toggleModal
    }), /*#__PURE__*/React.createElement(ModalContainer, {
      disableContainerBottomPadding: this.props.disableContainerBottomPadding
    }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(ModalHeaderTitleAndSubtitleSection, null), this.props.icon && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ModalIcon, {
      width: 96,
      height: 96,
      icon: this.props.icon
    }))), /*#__PURE__*/React.createElement(ModalBody, {
      type: ['body4', 'body5', 'body5'],
      color: ['gray700', 'gray600', 'gray600'],
      disableBodyPadding: this.props.disableBodyPadding
    }, this.props.bodyText && /*#__PURE__*/React.createElement("p", {
      dangerouslySetInnerHTML: getReactHtmlObject(this.props.bodyText)
    }), childrenWithProps), (this.props.secondaryButtonText || this.props.primaryButtonText || this.props.footerText) && /*#__PURE__*/React.createElement(ModalFooterSection, null))));
  }

}